// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailsLayout_container__3mjl9","panels":"DetailsLayout_panels__1A5q0"};